import axios from "@/api/axiosInstance";
import {
  FetchSessionsReportParams,
  FetchSessionsReportResponse,
} from "./types";

export const fetchSessionsReport = async (
  params: FetchSessionsReportParams = {},
): Promise<FetchSessionsReportResponse> => {
  const response = await axios.get<FetchSessionsReportResponse>(
    "/api/private/reports/sessions",
    { params },
  );
  return response.data;
};
